import Reveal from "./Reveal";

const STEPS = [
  {
    n: "01",
    t: "Elige tu servicio",
    d: "Lavado exterior, completo, detailing interior o pulido y cerámico. Tú decides el nivel de brillo.",
  },
  {
    n: "02",
    t: "Reserva tu franja",
    d: "Escríbenos por WhatsApp o usa el formulario y cerramos día y hora que te venga bien.",
  },
  {
    n: "03",
    t: "Brillamos en tu puerta",
    d: "Llegamos con agua, luz propia y productos premium. Tú solo disfrutas del resultado.",
  },
];

const Process = () => (
  <section id="proceso" className="relative py-24 md:py-32 border-t border-white/10">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.25em] text-aqua uppercase">— Cómo funciona</p>
        <h2 className="mt-4 font-display font-bold uppercase leading-[1.02] text-[clamp(2rem,4.5vw,3.6rem)]">
          Tres pasos, <span className="text-outline">cero esfuerzo</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div
              data-testid={`process-step-${s.n}`}
              className="border-t-2 border-white/10 pt-7 transition-colors duration-500 hover:border-aqua/60"
            >
              <p className="font-mono text-5xl font-semibold text-gold/90">{s.n}</p>
              <h3 className="mt-5 font-display text-xl md:text-2xl font-bold">{s.t}</h3>
              <p className="mt-3 text-white/60 leading-relaxed">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
